<template>
    <div class="">
        <!-- Task Header. -->
        <div class="flex items-center mb-1">
            <div class="w-16">
                <div
                    class="whitespace-pre-line text-sm m-0 px-2 py-1 font-bold text-gray-900 border-transparent rounded shadow-none relative focus:z-10"
                    v-text="reference"
                ></div>
            </div>
            <div class="flex-1 ml-0">
                <div
                    class="whitespace-pre-line text-sm m-0 px-2 py-1 font-bold text-gray-900 border-transparent rounded shadow-none relative focus:z-10"
                    v-text="name"
                ></div>
            </div>
        </div>
        <!-- Task Items. -->
        <application-for-payment-item v-for="item in task.items" :key="item.id"
                                      :readonly="readonly"
                                      :measurable="measurable"
                                      :task="task"
                                      @updated="$emit('updated')"
                                      :item="item"></application-for-payment-item>
        <div class="py-2"></div>
    </div>
</template>

<script>
import ApplicationForPaymentItem from "./ApplicationForPaymentItem.vue";

export default {
    components: {ApplicationForPaymentItem},
    props: {
        task: Object,
        readonly: Boolean,
        measurable: Boolean,
    },
    data() {
        return {
            reference: this.task.reference,
            name: this.task.name,
        }
    },
    methods: {
        canEdit() {
            return true
        },
    },
}
</script>
